import { APIClient } from "../base";

const ServiceApi = {
    getAll: async () => await APIClient.get('/services',{}),
    getDetail: async (id: number | string | any) => await APIClient.get('/services/' + id, {}),
}

export default ServiceApi;
